import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';
declare var $: any;

@Component({
  standalone: false,
  selector: 'app-edit-patient',
  templateUrl: './edit-patient.component.html',
  styleUrls: ['./edit-patient.component.css']
})
export class EditPatientComponent implements OnInit {

  addSubAdminForm: FormGroup | any;
  file: any;
  imageType: any;
  imageUrl: any;
  countryArr: any = [];
  patientId: any;
  viewPatientData: any;
  therapistList: any = [];
  weekDaysofTherapist: any = [];
  selectedDay: any;
  firstSlotId: any;
  therapistFullName: any;
  slotId: any;
  slotStatus: any;
  programList: any = [];
  programStatus: any;

  constructor(private service: MainService, private router: Router,
    private activatedroute: ActivatedRoute) {
    this.activatedroute.queryParams.subscribe((res) => {
      if (res) {
        const parseDta = JSON.parse(res.value);
        this.patientId = parseDta.id
        this.programStatus = parseDta.assignStatus;

      }
    })
  }

  ngOnInit() {
    this.addSubAdminFormValidation();
    this.getCountryCodeData();
    this.viewPatientApi();
    this.getTherapistList();
    this.viewProgramList();
  }

  // Add Subadmin Form Validation

  addSubAdminFormValidation() {
    this.addSubAdminForm = new FormGroup({
      'file': new FormControl(''),
      'phoneCode': new FormControl('+1'),
      'firstName': new FormControl('', Validators.compose([Validators.required, Validators.maxLength(62), Validators.pattern(/^[^\s][a-zA-Z ]*$/)])),
      'lastName': new FormControl(''),
      'therapyName': new FormControl(''),
      'programName': new FormControl(''),
      "email": new FormControl('', ([Validators.required, Validators.pattern(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/i), Validators.maxLength(50)])),
      "phoneNumber": new FormControl('', ([Validators.required, Validators.pattern(/^[1-9][0-9]{9,13}$/)])),

    })
  }

  getCountryCodeData() {
    this.service.getCountryCode().subscribe((res) => {
      this.countryArr = res
    })
  }

  ValidateFileUpload(event: any) {
    this.file = event.target.files;
    if (this.file[0]) {
      this.imageType = this.file[0].type;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imageUrl = e.target.result;
        this.uploadImage();
      };
      reader.readAsDataURL(this.file[0]);
    }
  }

  // program list api inntegration 
  viewProgramList() {
    this.service.getApi(ApiUrls.programList, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.programList = res.result;
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    }, err => {
      this.service.errorToast(err.responseMessage)
    })
  }

  // To get therapist api integration 

  getTherapistList() {
    const data = {
      "search": "",
    }
    this.service.showSpinner();
    this.service.postApi(ApiUrls.therapistList, data, 1).subscribe((res) => {
      this.service.hideSpinner();
      if (res.responseCode == 200) {
        // this.service.successToast(res.responseMessage);
        this.therapistList = res.result;
      }
    })
  }


  // To get patient details by view patient api integration 

  viewPatientApi() {
    this.service.showSpinner();
    this.service.getApi(ApiUrls.viewPatient + `?userId=${this.patientId}`, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.viewPatientData = res.userData;
        this.imageUrl = this.viewPatientData.profilePic;
        this.addSubAdminForm.patchValue({
          firstName: this.viewPatientData.firstName,
          lastName: this.viewPatientData.lastName,
          email: this.viewPatientData.email,
          phoneNumber: this.viewPatientData.mobileNumber,
          phoneCode: this.viewPatientData.countryCode
        })
        this.service.hideSpinner();
      }
      else {
        this.service.hideSpinner();
      }
    })
  }

  // upload Image api integration 
  uploadImage() {
    const data: FormData = new FormData();
    data.append('image', this.file[0])
    this.service.postApi(ApiUrls.uploadImage, data, 3).subscribe((res) => {
      if (res.responseCode == 200) {
        this.imageUrl = res.result.image
      }
    })
  }

  // edit patient api integration
  editPatientApi() {
    if (this.programStatus == "notAssign") {
      this.assignProgramApi()
    }
    else {
      const data = {
        firstName: this.addSubAdminForm.value.firstName,
        lastName: this.addSubAdminForm.value.lastName,
        email: this.addSubAdminForm.value.email,
        countryCode: this.addSubAdminForm.value.phoneCode,
        mobileNumber: this.addSubAdminForm.value.phoneNumber,
        profilePic: this.imageUrl,
        password: this.addSubAdminForm.value.Password,
        // programId : this.addSubAdminForm.value.programName
      }

      this.service.showSpinner()
      this.service.putApi(ApiUrls.editPatient + `?userId=${this.patientId}`, data, 1).subscribe((res) => {
        this.service.hideSpinner();
        if (res.responseCode == 200) {
          this.service.successToast(res.responseMessage)
          this.router.navigate(['/patient-mgt'])
        }
        else {
          this.service.errorToast(res.responseMessage)
        }
      }, err => {
        this.service.hideSpinner();
        this.service.errorToast(err.responseMessage)
      })
    }

  }

  // assign Therapist api integration

  // edit patient api integration
  assignTherapistApi() {
    const data = {
      patientId: this.patientId,
      slotId: this.slotId
    };

    this.service.showSpinner()
    this.service.postApi(ApiUrls.assignTherapist, data, 1).subscribe((res) => {
      this.service.hideSpinner();
      if (res.responseCode == 200) {
        $('#therapistCalender').modal('hide');
        this.service.successToast(res.responseMessage)
        // this.router.navigate(['/patient-mgt'])
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    }, err => {
      this.service.hideSpinner();
      this.service.errorToast('Patient need to program subscribe first')
    })
  }

  // edit patient api integration
  assignProgramApi() {
    const data = {
      userId: this.patientId,
      programId: this.addSubAdminForm.value.programName
    };
    this.service.showSpinner()
    this.service.postApi(ApiUrls.assign_program, data, 1).subscribe((res) => {
      this.service.hideSpinner();
      if (res.responseCode == 200) {
        this.service.successToast(res.responseMessage)
        this.router.navigate(['/patient-mgt'])
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    }, err => {
      this.service.hideSpinner();
    })
  }



  // get slot for therapist api integration 

  getSlotofTherapistApi(id: any) {
    let splitData = id.split('/');
    this.therapistFullName = splitData[1] + ' ' + splitData[2]
    this.service.showSpinner();
    this.service.getApi(ApiUrls.getSlotFor_booking + `?userId=${splitData[0]}`, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        $('#therapistCalender').modal('show')
        this.weekDaysofTherapist = res.result;

        this.service.hideSpinner();
      }
      else {
        this.service.hideSpinner();
      }
    })
  }

  dateChange(id: any) {
    this.selectedDay = id;
  }

  assignTherapistModalAlert(slotId: any, status: any) {
    this.slotId = slotId;
    this.slotStatus = status;
    if (status == 'BOOKED') {
      return false
    }
    else {
      $('#assignTherapist').modal('show');
    }

  }

  slotChange() {
    $('#assignTherapist').modal('hide');
    if (status == 'BOOKED') {
      $('#therapistCalender').modal('hide');
      this.service.errorToast('This slot is already booked , please choose other slot');
      return false
    }
    else {
      this.assignTherapistApi();
    }

  }

  // Block special character from name
  inputkeyPress(e: any) {
    var k
    if (e.charCode == 32 && !e.target.value) {
      e.preventDefault()
    }
    else {
      document.all ? k = e.keyCode : k = e.which;
      return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32);
    }
  }
  //Allow only numbers
  inputKeyPress(e: any) {
    var k
    if (e.charCode == 32 && !e.target.value) {
      e.preventDefault()
    }
    else {
      document.all ? k = e.keyCode : k = e.which;
      return ((k > 47 && k < 58) || k == 8);
    }
  }

  //For password keypres
  passwordKeyPress(e: any) {
    if (e.charCode == 32 && !e.target.value) {
      e.preventDefault()
    }
  }

  onImageError(event: any) {
    event.target.src = 'https://res.cloudinary.com/smsit/image/upload/v1597335652/fmcvdi2g6ogd5vwzvzfa.jpg';
  }

}
